import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';

import ButtonStyles from '../../../styles/button';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import combineStyles from '../../../utils/combineStyles';
import { isPermissible } from '../PermissionResolver';
import { AppContext } from '../../../AppProvider';

const styles = () => ({
  editButton: {
    height: '28px !important',
    padding: 0
  },
  buttonRoot: {
    padding: 0,
    top: '-1px',
    minWidth: '44px',
    '&:hover': {
      backgroundColor: '#fff'
    }
  }
});
export class EditButton extends PureComponent {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
    permission: PropTypes.string
  };

  render() {
    const { onClick, classes, t, permission = null } = this.props;
    const isPermitted =
      !permission || isPermissible(this.context.globalProps, permission);

    return (
      isPermitted && (
        <Button
          className={classnames(classes.editButton)}
          onClick={onClick}
          color={'primary'}
          variant={'text'}
          disableRipple={true}
          classes={{
            label: classes.buttonLabelSecondaryAction,
            root: classes.buttonRoot
          }}
        >
          {t('EDIT')}
        </Button>
      )
    );
  }
}

EditButton.contextType = AppContext;
const translatedEditButton = withNamespaces()(EditButton);
export default withStyles(combineStyles(styles, ButtonStyles))(
  translatedEditButton
);
